"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ts = ts;
exports.st = st;
const lang_1 = __importDefault(require("./locale/lang"));
function ts(v, ...rest) {
    let output = '';
    output = String(lang_1.default[v] || v);
    rest.forEach((value, idx) => {
        output = output.replace(`$${idx}`, String(value));
        //add for second parameter like "abc $0 abcde $0"
        output = output.replace(`$${idx}`, String(value));
    });
    // replace all occurrences of `DOLLAR_SIGN_` with `$`
    rest.forEach(() => {
        output = output.replace('DOLLAR_SIGN_', String('$'));
    });
    if (output.includes('GOCARDLESS_PRIVACY_LINK') || output.includes('GOCARDLESS_TERMS_LINK')) {
        output = output.replace('GOCARDLESS_PRIVACY_LINK', String('<a href="https://gocardless.com/privacy/" target="_blank" rel="noopener noreferrer">privacy notices</a>'));
        output = output.replace('GOCARDLESS_TERMS_LINK', String('<a href="https://gocardless.com/legal/gdpr/" target="_blank" rel="noopener noreferrer">GoCardless Website Terms of Use</a>'));
    }
    return output;
}
;
/**
 * Reverse lookup: given a translated text, return the matching key from LANG.
 * If no exact match is found, returns the original input text.
 */
function st(text) {
    // Find the first key in LANG whose value matches exactly
    for (const [key, value] of Object.entries(lang_1.default)) {
        if (String(value) === text) {
            return key;
        }
    }
    // No match — return the original text
    return text;
}
